import { useEffect } from "react";

import styles from "./WidgetBtn.module.scss";
import icon from "./btnIcon.svg";

const WidgetButton = ({
  widgetId,
  text,
  btnIcon,
}: {
  widgetId: string;
  text: string;
  btnIcon: string;
}) => {
  useEffect(() => {
    (function (win, doc, url) {
      let sws = doc.createElement("script");
      sws.type = "text/javascript";
      sws.async = true;
      sws.src = url;

      let pfs = doc.getElementsByTagName("script")[0];
      // @ts-ignore
      pfs.parentNode.insertBefore(sws, pfs);
    })(
      window,
      document,
      `https://site.sbis.ru/consultant-widget/script/${widgetId}`,
    );
  }, [widgetId]);

  return (
    <>
      <script type="text/javascript" data-saby-widget={widgetId}></script>
      <button className={styles.mainButton}>
        <div className={styles.wrapper}>
          <img src={btnIcon} alt="Иконка" className={styles.btnIcon} />
          <p className={styles.buttonText}>{text}</p>
        </div>
        <img src={icon} alt="Иконка" className={styles.icon} />
      </button>
    </>
  );
};

export default WidgetButton;
